<alert code="{{code}}" message="{{message}}"></alert>
<div class="card">
    <div class="card-body" *ngIf="resetDone">
        <h3 class="card-title">Password reset successfully </h3>
        <p>Your password has been reset, you will need to sign in one more time to access the resources you requested. </p>
        <ng-template [ngIf]='continueUrl !== null'>
            <a class="btn btn-primary btn-lg q-button" role="button" href="{{continueUrl}}">
                Back to sign in screen
            </a>
        </ng-template>
        
    </div>
    <div class="card-body" *ngIf="!resetDone">
        <h3 class="card-title">Set a new password</h3>
        <form [formGroup]="frmSetNewPassword" (ngSubmit)="setPassword()">
            <div class="mb-3">
                <label class="form-label" for="password">New Password</label>
                <input class="form-control" 
                type="password" 
                name="password" 
                formControlName="password"
                id="password">
            </div>
            <div class="mb-3">
                <label class="form-label" for="confirmPassword">Confirm New Password</label>
                <input class="form-control" 
                type="password" 
                name="confirmPassword" 
                formControlName="confirmPassword"
                id="confirmPassword">
            </div>
            <div class="password-policy">
                <p>Password policy:</p>
                <ul>
                    <li>10 characters or more</li>
                    <li>Contain lower case letter</li>
                    <li>Contain upper case letter</li>
                    <li>Contain special character</li>
                    <li>Contain a number</li>
                </ul>
            </div>
            <br/>

            <button class="btn btn-primary btn-lg q-button" type="submit" [disabled]='!!requestPending'>
                <span>Reset</span>
            </button>
            <ng-template [ngIf]='!!requestPending'>
                <app-progress-bar></app-progress-bar>
            </ng-template>
        </form>
    </div>
</div>